module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-13.8f1bfb03.png";